@use '@lib/assets/styles/main.scss' as *;

.chip {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.013px;
}
